import React from "react";

const PersonContext = React.createContext({});
PersonContext.displayName = "PersonContext";

export default PersonContext;
